import { Injectable } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';

/** Reuses the existing identity transport while its other callers remain AngularJS. */
@Injectable({ providedIn: 'root' })
export class IdentityService {
    constructor(private upgrade: UpgradeModule) {}
    private get identity(): IdentityClient { return this.upgrade.$injector.get('idServerService'); }
    public getCurrentUser(): Promise<IdentityUserDetails> { return Promise.resolve(this.identity.currentUserDetails()); }
    public getUser(userName: string): Promise<IdentityUserDetails> { return Promise.resolve(this.identity.userDetails(userName)); }
    public enableTwoFactor(userName: string, type: string): Promise<unknown> { return Promise.resolve(this.identity.addTwoFactor(userName, type)); }
    public disableTwoFactor(userName: string): Promise<unknown> { return Promise.resolve(this.identity.removeTwoFactor(userName)); }
}
export interface IdentityUserDetails { userName: string; isCompanyAdmin?: boolean; twoFactorEnabled?: boolean; twoFactorType?: string; }
interface IdentityClient {
    currentUserDetails(): PromiseLike<IdentityUserDetails>;
    userDetails(userName: string): PromiseLike<IdentityUserDetails>;
    addTwoFactor(userName: string, type: string): PromiseLike<unknown>;
    removeTwoFactor(userName: string): PromiseLike<unknown>;
}
